import type { MonetizingRegion } from '@openx/types/monetizing';

export const pacingRegionLabels: Record<MonetizingRegion, string> = {
  ASIA: 'APAC',
  EU: 'EU',
  US: 'NA & LATAM',
};
